import { client } from '../http';

export default {
  async disableBoti(reason) {
    return await client.post('/api/boti/state/auto-send', { on: false, reason });
  },
};



// WEBPACK FOOTER //
// ./src/api/CommunicationStateApi.js